(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-careers-listings"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const filterButtons = document.querySelectorAll('.filter-button');
  const jobCards = document.querySelectorAll('.job-card');

  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      const filter = button.getAttribute('data-filter');
      
      // Update active button
      filterButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // Filter job cards
      jobCards.forEach(card => {
        if (filter === 'all') {
          card.style.display = 'flex';
        } else {
          const department = card.getAttribute('data-department');
          card.style.display = department === filter ? 'flex' : 'none';
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
